import { KeyboardEventHandler, MouseEventHandler } from 'react';

export function handleClick(
	canClick: boolean,
	onClick?: () => void
): MouseEventHandler<HTMLDivElement> {
	if (canClick && onClick) return onClick;

	return function () {
		return;
	};
}

export function handleKeyPress(
	canClick: boolean,
	onKeyEnter?: () => void
): KeyboardEventHandler<HTMLDivElement> {
	return function (e) {
		if (e.key === 'Enter' && canClick && onKeyEnter) {
			onKeyEnter();
		}
	};
}
